<template>
  <div class="result">
    <AppNavbar
      v-if="isApp"
      :options="options"
      :zIndex="20"
      :title="title"
      :placeholder="true"
    >
      <template slot="right">
        <div class="share iconfont icon-share" @click="bindShare"></div>
      </template>
    </AppNavbar>
    <div v-if="detailData">
      <div class="user-info">
        <div class="avatar">
          <img class="a-image" :src="detailData.head_img" alt="" />
          <div
            class="red"
            v-if="detailData.remind && detailData.remind.is_popup && isApp"
          ></div>
        </div>
        <div class="u-center">
          <div class="nickname">{{ detailData.truename }}</div>
          <div class="w-info">
            <span>当前体重</span>
            <span class="w-unit">{{ detailData.weight }} KG</span>
            <span>目标体重</span>
            <span class="w-unit">{{ detailData.target_weight }} KG</span>
          </div>
        </div>
        <div class="my-collect" @click="bindCollect" v-if="!$route.query.id"
          >我收藏的方案<span class="iconfont icon-you"></span
        ></div>
      </div>
      <div class="c-content">
        <div class="content" v-if="detailData.base_data">
          <div class="title" v-if="!isShare">
            <div class="text">精准饮食方案</div>
            <div
              class="collect"
              @click="bindThrottleCollect"
              :class="{ 'collect-active': detailData.is_collection }"
            >
              <span class="iconfont icon-shoucang2"></span>收藏
            </div>
          </div>
          <div class="c-1">
            <div class="c-title">每日推荐摄入总量</div>
            <div class="c-i-content">
              <div class="c-i-left">
                <div class="type-list">
                  <div
                    class="type-item"
                    v-for="(item, index) in detailData.base_data.calorificData"
                    :key="index"
                  >
                    <div
                      class="item-line"
                      :style="{ background: item.itemStyle.color }"
                    ></div>
                    <div class="item-name">{{ item.name }}</div>
                    <img
                      class="item-dash"
                      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/793f7dd1f9fd79be4363cb9831fea5ec.png"
                    />
                    <div class="item-num">{{ item.value }}</div>
                    <div class="item-unit">g</div>
                  </div>
                </div>
              </div>
              <div class="c-i-right">
                <CircleEcharts
                  :data="detailData.base_data.calorificData"
                  :kcalNum="detailData.base_calorific"
                />
              </div>
            </div>
          </div>
          <div class="c-2">
            <div class="c-title">每餐推荐摄入量</div>
            <div class="c-i-table">
              <div
                class="table-c"
                v-for="(item, index) in detailData.base_data.threeMeals"
                :key="index"
              >
                <div class="t-title c-td">{{ item.name }}</div>
                <div
                  class="c-td t-body"
                  v-for="(item1, index1) in detailData.base_data.mealsMaxLength"
                  :key="index1"
                  :style="{ background: colorList[index1] }"
                >
                  <span v-if="item.list[index1]">
                    {{ item.list[index1].name
                    }}{{ item.list[index1].weight }}g</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="nav-list">
            <div
              class="nav-item"
              v-for="(item, index) in navList"
              :key="index"
              @click="bindChangeNav(index)"
            >
              {{ item }}</div
            >
            <div
              class="nav-item-active"
              :style="{ left: getLeftPercent(curNav, navList) }"
              >{{ navList[curNav] }}
            </div>
          </div>
          <div
            v-for="(fooditem, foodindex) in detailData.base_data.meal_list"
            :key="foodindex"
          >
            <div class="food-content" v-show="curNav == foodindex">
              <div
                class="food-item"
                :style="{ background: colorData[item.name].color3 }"
                v-for="(item, index) in fooditem.food_list"
                :key="index"
              >
                <div
                  class="food-title"
                  :style="{ background: colorData[item.name].color2 }"
                >
                  <img class="f-icon" :src="colorData[item.name].icon" alt="" />
                  <span class="f-title">{{ item.name }}</span>
                  <span class="f-weight">{{ item.gram_number }}g</span>
                </div>
                <!-- <div class="food-change" @click="bindReplace(item)" v-if="!item.is_change"><span
                                    class="iconfont icon-shuaxin"
                                    :class="{'refresh':item.replacing}"></span><span>换一换</span></div> -->
                <div class="food-list">
                  <div
                    class="f-item"
                    v-for="(item1, index1) in item.food_type_list"
                    :key="index1"
                    @click="bindFoodDetail(item1)"
                  >
                    <div class="f-image-c">
                      <img class="f-image" :src="item1.image_url" alt="" />
                      <img
                        class="f-super"
                        v-if="item1.is_super"
                        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/159a9ada5ca72d0571bd0c2464441200.png"
                        alt=""
                      />
                    </div>
                    <div class="f-right">
                      <div class="f-r-name"
                        >{{ item1.name }} {{ item1.transform_weight }}g</div
                      >
                      <div class="f-r-desc"
                        >{{ filterUnit(item1, item.name) }}/100g</div
                      >
                    </div>
                    <img
                      class="goods"
                      v-if="item1.is_goods"
                      @click.stop="bindBuyGoods(item1)"
                      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e5b485c73fe9f9994c40bdb09a64afcd.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="consult-content"
          v-if="CommonIncomingData"
          @click="jumpToStarPage"
        >
          <img
            class="avatar"
            :src="CommonIncomingData.head_portrait"
            alt=""
            v-buried
            data-buried="BG_YSJSQ_YYSZY"
            v-clickBuried
            data-click-buried="CLICK_YSJSQ_YYSZY"
          />
          <div class="right">
            <div class="coach-name">{{ CommonIncomingData.name }}</div>
            <div class="desc">{{ CommonIncomingData.title }}</div>
          </div>
          <!--   <div class="c-btn" @click.stop="jumpIncoming" v-clickBuried data-click-buried="CLICK_YSJSQ_ZX" >立即咨询</div> -->
        </div>
      </div>
      <div class="btn-content" v-if="!isShare && isApp">
        <div class="tip-content" v-show="showTip && isApp" @click="bindCloseTip"
          ><span>若身体数据发生变化, 可以重新生成饮食方案哦</span
          ><span class="close iconfont icon-cha"></span>
        </div>
        <div class="btn-item">
          <div @click="bindReCreate">重新计算</div>
        </div>
        <div class="btn-item btn-confirm" @click="bindBuyVip">全年食谱定制</div>
      </div>
      <div class="banner" v-if="isApp">
        <img
          class="image"
          :src="item.img"
          v-for="(item, index) in BannerData"
          :key="index"
          alt=""
          @click="bindClickAdv(item)"
        />
      </div>
      <div class="h5-padding"></div>
      <div class="download-app" @click="bindDownloadApp" v-if="!isApp"
        >下载 betterwe星球APP</div
      >
      <ShareComponent
        v-model="showShare"
        :shareType="shareType"
        :copyUrl="copyUrl"
        :hideIconId="4"
        :shareOptions="shareOptions"
      />
      <UpdateToast
        v-if="detailData.remind && isApp"
        v-model="detailData.remind.is_popup"
        :msg="detailData.remind.msg"
        @confirm="bindToastConfirm"
      />
      <PosterComponent class="poster" :data="detailData" :curIndex="curNav" />
    </div>
    <AppLoading v-else class="loading"></AppLoading>
  </div>
</template>
<script>
import {
  recommendData,
  recommendTotalData,
  colorData,
  foodTypeObj
} from './data.js'
import { throttle } from '@/common/common.js'
import AppLoading from '@/components/app/loading/loading.vue'
import ShareComponent from '@/components/app/share/share-image.vue'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import CircleEcharts from './components/circle.vue'
import UpdateToast from './components/update-toast.vue'
import PosterComponent from './components/poster.vue'
export default {
  components: {
    ShareComponent,
    AppNavbar,
    CircleEcharts,
    UpdateToast,
    PosterComponent,
    AppLoading
  },
  data() {
    return {
      isApp: true,
      showShare: false,
      shareOptions: {
        //分享的数据的格 式
        //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'url',
        desc: '快来看看国家营养师团队为我生成的健康减脂饮食方案吧！',
        title: '减脂饮食方案',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0a8865341b353336bfe340f5e9ebf087.png' // 分享的缩略图的url
      },
      shareType: 1,
      copyUrl: '',
      options: {
        barBackgroundColor: 'transparent'
      },
      showTip: false,
      title: '饮食计算器',
      loaded: false,
      navList: ['早餐', '午餐', '晚餐'],
      curNav: 0,
      colorList: [
        'linear-gradient(360deg, rgba(207,239,249,0.12) 0%, rgba(161,219,240,0.2) 100%)',
        'linear-gradient(360deg, rgba(255,238,177,0.12) 0%, rgba(255,216,121,0.2) 100%)',
        'linear-gradient(360deg, rgba(216,244,212,0.12) 0%, rgba(189,234,183,0.2) 100%)',
        'linear-gradient(360deg, rgba(236,229,255,0.12) 0%, rgba(222,212,255,0.2) 100%)'
      ],
      colorData: colorData,
      detailData: null,
      recommendTotalData: recommendTotalData, //推荐饮食总量
      recommendData: recommendData, //推荐饮食数据
      isCollect: false,
      BannerData: [],
      dailyEatData: [
        {
          title: '早餐',
          list: [
            {
              food: '蛋白质',
              weight: 50
            },
            {
              food: '蛋白质',
              weight: 50
            },
            {
              food: '蛋白质',
              weight: 50
            },
            {
              food: '蛋白质',
              weight: 50
            }
          ]
        },
        {
          title: '午餐',
          list: [
            {
              food: '蛋白质',
              weight: 50
            },
            {
              food: '蛋白质',
              weight: 50
            },
            {
              food: '蛋白质',
              weight: 50
            }
          ]
        },
        {
          title: '晚餐',
          list: [
            {
              food: '蛋白质',
              weight: 50
            },
            {
              food: '蛋白质',
              weight: 50
            },
            {
              food: '蛋白质',
              weight: 50
            }
          ]
        }
      ],
      refresh: false,
      isShare: false, //是否是分享页面进入
      CommonIncomingData: null
    }
  },
  created() {
    this.addScrollEvent()
    this.getData()
    this.getBanner()
    this.bindThrottleCollect = throttle(this.bindChangeCollect, 1000) //节流函数
    this.showTip = !localStorage.getItem('diet-calculator-tip')
    this.isShare = this.$route.query.share
    this.isApp = this.$http._isApp()
    this.getCommonIncomingUrl()
  },
  mounted() {
    //曝光_精准饮食计算器结果页
    this.$buryPoint('CLICK_JSQ_SHENGCHENG')
  },
  beforeDestroy() {
    this.removeScrollEvent()
  },
  methods: {
    filterUnit(item, name) {
      let arr = ['碳水', '蛋白质']
      if (arr.includes(name)) {
        return '含' + name + parseInt(item.transform_value) + 'g'
      } else {
        return parseInt(item.calory) + 'Kcal'
      }
    },
    bindDownloadApp() {
      location.href = 'https://member3.gymcity.com.cn/#/app-download'
    },
    bindClickAdv(item) {
      if (this.$http._isApp()) {
        item.router && this.$betterwe.onAppPageRoute(item.router)
      } else {
        this.bindDownloadApp()
      }
    },
    getBanner() {
      let params = {
        position_type: 19, //位置类型
        resource_type: 11 //资源位类型
      }
      this.$http
        .getAdvData(
          'member/ResourceLocation/getShowResourceLocationNew',
          params
        )
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.BannerData = res.data
          }
        })
        .catch((err) => {})
    },
    bindCloseTip() {
      this.showTip = false
      localStorage.setItem('diet-calculator-tip', 1)
    },
    getData() {
      let params = {
        id: this.$route.query.id || ''
      }
      let url = this.$route.query.share
        ? 'member/DietCalculate/getShareData'
        : 'member/DietCalculate/judgeUserOwnDietCal'
      this.$http.getBaseApp(url, params).then((res) => {
        res = res.data
        if (res.code == 200) {
          this.detailData = this.filterData(res.data)
          /* 设置分享链接 */
          this.copyUrl =
            location.protocol +
            '//' +
            location.hostname +
            location.pathname +
            '?id=' +
            this.detailData.id +
            '&share=true'
          //设置分享title
          this.shareOptions.title = this.detailData.truename + '的减脂饮食方案'
        } else if (res.code == -2) {
          this.$router.replace('/diet-calculator/index')
        } else if (res.code == -1) {
          this.$betterwe.isLogin(() => {
            this.getData()
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    //处理后端数据
    filterData(detail) {
      let data = detail.base_data
      if (data) {
        //每日摄入总量数据处理
        data.calorificData.drink_num = undefined
        let arr = []
        for (let key in foodTypeObj) {
          if (data.calorificData[key]) {
            arr.push({
              value: data.calorificData[key],
              name: foodTypeObj[key].name,
              itemStyle: { color: foodTypeObj[key].color }
            })
          }
        }
        data.calorificData = arr
        data.baseCalorific = parseInt(data.baseCalorific) //总热量取整
        //每日推荐摄入量数据处理
        let max = 0
        data.threeMeals = data.threeMeals.map((item) => {
          let list = []
          for (let key in foodTypeObj) {
            if (item[key]) {
              list.push({
                name: foodTypeObj[key].name,
                weight: item[key]
              })
            }
          }
          item.list = list
          if (list.length > max) {
            max = list.length
          }
          return item
        })
        data.mealsMaxLength = max
        data.meal_list = data.meal_list || []
        data.meal_list.map((item) => {
          item.food_list.map((item1) => {
            item1.replacing = false
          })
        })
      }
      detail.base_calorific = parseInt(detail.base_calorific)
      detail.weight = parseFloat(detail.weight)
      detail.target_weight = parseFloat(detail.target_weight)
      detail.remind.is_popup = !!detail.remind.is_popup
      return detail
    },
    addScrollEvent() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindScroll(e) {
      let scrollTop =
        e.target.documentElement.scrollTop ||
        e.target.body.scrollTop ||
        e.target.pageYOffset
      if (scrollTop >= 50) {
        this.options = {
          barBackgroundColor: '#fff',
          color: 'rgba(0,0,0.8)'
        }
      } else {
        this.options = {
          barBackgroundColor: 'rgba(255, 255, 255, 0)',
          color: 'rgba(0,0,0.8)'
        }
      }
    },
    getLeftPercent(index, list) {
      let everyWidth = 1 / list.length
      let res = index * everyWidth + everyWidth / 2
      return (res * 100).toFixed(2) + '%'
    },
    bindChangeNav(index) {
      this.curNav = index
    },
    bindClick() {
      this.showShare = true
    },
    bindShare() {
      //点击_饮食计算器结果页分享按钮
      this.$buryPoint('CLICK_JSQ_FX')
      this.showShare = true
    },
    //去我的收藏
    bindCollect() {
      //点击_饮食计算器收藏的方案按钮
      this.$buryPoint('CLICK_JSQ_SHOUCANG')
      this.$router.push('/diet-calculator/collect')
    },
    //收藏或者取消收藏
    bindChangeCollect() {
      let type = this.detailData.is_collection ? 0 : 1
      let params = {
        id: this.detailData.id,
        type
      }
      this.$http
        .postBaseApp('member/DietCalculate/editCollection', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.detailData.is_collection = type
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    bindCoach() {
      if (!this.isApp) {
        this.bindDownloadApp()
        return
      }
      this.$router.push('/diet-calculator/analyze')
    },
    /* 食物换一换 */
    bindReplace(item) {
      let params = {
        expand_id: item.expand_id,
        meal_type: this.curNav + 1,
        food_type: item.food_type
      }
      if (item.replacing) {
        return
      }
      item.replacing = true
      this.$http
        .postBaseApp('member/DietCalculate/updateDiet', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            setTimeout(() => {
              this.$toast('更换成功')
              item.food_type_list = res.data
              item.is_change = true
            }, 300)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          setTimeout(() => {
            item.replacing = false
          }, 300)
        })
    },
    //重新生成饮食方案
    bindReCreate() {
      this.$router.replace('/diet-calculator/question')
    },
    //点击更新弹框的确认按钮
    bindToastConfirm() {
      let params = {
        id: this.detailData.id
      }
      this.$http
        .postBaseApp('member/DietCalculate/deleteDiet', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$router.push('/diet-calculator/question')
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    //进入食物详情页
    bindFoodDetail(item) {
      if (!this.isApp) {
        this.bindDownloadApp()
        return
      }
      if (item.is_super) {
        this.$router.push({
          path: '/calorie-query/super-food-detail',
          query: {
            id: item.food_id
          }
        })
      } else {
        this.$router.push({
          name: 'calorie-query-food-info',
          query: { foodid: item.food_id }
        })
      }
    },
    //购买
    bindBuyGoods(item) {
      if (item.is_goods && item.jump_type && item.jump_url) {
        this.$betterwe.jumpRoute(item.jump_url)
      }
    },
    async getCommonIncomingUrl() {
      let res = await this.$http
        .getBaseApp('api/v3/expert/getCommonIncomingUrl', { source_type: 7 })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.CommonIncomingData = res.data
        }
      }
    },
    jumpToStarPage() {
      this.$betterwe.jumpRoute(this.CommonIncomingData.router)
    },
    jumpIncoming() {
      this.$betterwe.jumpRoute(this.CommonIncomingData.incoming_url)
    },
    bindBuyVip() {
      this.$betterwe.vipHomePage()
    }
  }
}
</script>
<style lang="scss" scoped>
.result {
  user-select: none;
  padding: 0px 20px 20px;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #f9f9f9;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/be9ad79d435193923146b11c024e9976.png');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center top;

  .poster {
    position: fixed;
    width: 100%;
    height: 100%;
    left: -200%;
    top: 0;
    z-index: -1;
  }

  .user-info {
    padding-top: 10px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;

    .u-center {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
    }

    .avatar {
      width: 46px;
      height: 46px;
      margin-right: 8px;
      position: relative;

      .a-image {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        overflow: hidden;
        object-fit: cover;
        box-sizing: border-box;
        border: 2px solid #fff;
      }

      .red {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 12px;
        height: 12px;
        background-color: #f04646;
        border-radius: 50%;
        box-sizing: border-box;
        border: 2px solid #fff;
      }
    }

    .nickname {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 16px;
      margin-bottom: 11px;
    }

    .w-info {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.6);
      line-height: 16px;

      .w-unit {
        font-size: 18px;
        font-family: DINCondensed-Bold, DINCondensed;
        font-weight: bold;
        color: #6236ff;
        line-height: 16px;
        margin-left: 4px;
        margin-right: 8px;
      }
    }

    .my-collect {
      padding: 0px 4px 0px 9px;
      height: 20px;
      border-radius: 10px;
      border: 1px solid #6236ff;
      font-size: 10px;
      color: #6236ff;
      display: flex;
      align-items: center;

      .iconfont {
        font-size: 12px;
      }
    }
  }

  .c-content {
    margin-bottom: 16px;
    overflow: hidden;
    background: #ffffff;
    border-radius: 12px;
  }

  .content {
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 12px;
    padding: 16px 20px 0px;

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;

      .text {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
      }

      .collect {
        width: 63px;
        height: 26px;
        background: #f5f2ff;
        border-radius: 13px;
        font-weight: bold;
        font-size: 12px;
        color: #888;
        display: flex;
        align-items: center;
        justify-content: center;

        .iconfont {
          font-size: 14px;
          margin-right: 3px;
        }
      }

      .collect-active {
        color: #815eff;
      }
    }

    .c-title {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      margin-bottom: 12px;
    }

    .c-1 {
      margin-bottom: 16px;

      c-title {
        margin-bottom: 5px;
      }

      .c-i-content {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .c-i-left {
          width: 140px;

          .type-list {
            .type-item {
              display: flex;
              align-items: center;
              margin-bottom: 13px;

              .item-line {
                width: 3px;
                height: 14px;
                background-color: rgba(161, 219, 240, 1);
                margin-right: 10px;
              }

              .item-name {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(0, 0, 0, 0.8);
                line-height: 16px;
                margin-right: 2px;
              }

              .item-dash {
                flex: 1;
                flex-shrink: 0;
                overflow: hidden;
                height: 2px;
                object-fit: cover;
                margin-right: 2px;
              }

              .item-num {
                font-size: 20px;
                font-family: DINAlternate-Bold, DINAlternate;
                font-weight: bold;
                color: #333333;
                line-height: 22px;
                margin-right: 4px;
              }

              .item-unit {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(0, 0, 0, 0.8);
                line-height: 16px;
              }
            }

            .type-item:last-child {
              margin-bottom: 0;
            }
          }
        }

        .c-i-right {
          width: 106px;
          height: 106px;
        }
      }
    }

    .c-2 {
      margin-bottom: 33px;

      .c-i-table {
        display: flex;
        align-items: flex-start;
        border-radius: 12px;
        overflow: hidden;

        .table-c {
          width: 33%;
          margin-right: 0.5%;
        }

        .t-body {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.8);
          line-height: 16px;
        }

        .t-title {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 16px;
        }

        .c-td {
          //text-indent: 16px;
          padding-left: 16px;
          padding-right: 5px;
          height: 24px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          line-height: 24px;
          background: linear-gradient(
            180deg,
            #fafafa 0%,
            rgba(229, 229, 229, 0.1) 100%
          );
        }

        .table-c:last-child {
          margin-right: 0px;
        }
      }
    }

    .nav-list {
      position: relative;
      display: flex;
      align-items: center;
      width: 240px;
      height: 26px;
      background: #f5f5f6;
      border-radius: 14px;
      margin: 0 auto;
      text-align: center;
      margin-bottom: 23px;

      .nav-item {
        flex: 1;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 16px;
      }

      .nav-item-active {
        position: absolute;
        top: 50%;
        left: 16.66%;
        transform: translate(-50%, -50%);
        width: 80px;
        height: 32px;
        background: #ffffff;
        box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.05);
        border-radius: 16px;
        border: 1px solid #e2e2e2;
        box-sizing: border-box;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #6236ff;
        line-height: 32px;
        transition: left 0.2s ease;
      }
    }

    .food-content {
      .food-item {
        position: relative;
        border-radius: 12px;
        background-color: rgba(255, 216, 121, 0.2);
        padding-bottom: 20px;
        margin-bottom: 16px;

        .food-title {
          display: inline-flex;
          padding: 8px;
          min-width: 126px;
          overflow: hidden;
          align-items: center;
          border-radius: 12px 0px 12px 0px;
          background-color: rgba(255, 216, 121, 1);
          margin-bottom: 20px;

          .f-icon {
            width: 20px;
            height: 20px;
            object-fit: contain;
            margin-right: 4px;
          }

          .f-title {
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.8);
            line-height: 20px;
            margin-right: 4px;
          }

          .f-weight {
            font-size: 20px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.8);
            line-height: 20px;
          }
        }

        .food-change {
          padding: 2px 6px;
          position: absolute;
          right: 16px;
          top: 8px;
          background: linear-gradient(270deg, #ffffff 0%, #ffffff 100%);
          border-radius: 10px;
          font-size: 11px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.6);
          line-height: 16px;
          display: flex;
          align-items: center;

          .iconfont {
            margin-right: 4px;
            font-size: 16px;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.6);
          }

          .refresh {
            animation: myrotate 1.5s linear infinite;
          }

          @keyframes myrotate {
            0% {
              transform: rotate(0deg);
            }

            100% {
              transform: rotate(360deg);
            }
          }
        }

        .food-list {
          padding: 0px 16px;

          .f-item {
            position: relative;
            display: flex;
            align-items: center;
            background: #ffffff;
            border-radius: 12px;
            border: 1px solid #f1f1f1;
            box-sizing: border-box;
            margin-bottom: 14px;

            .goods {
              position: absolute;
              right: 10px;
              top: 50%;
              transform: translate(0%, -50%);
              width: 20px;
              height: 20px;
              object-fit: contain;
            }

            .f-image-c {
              position: relative;
              width: 60px;
              height: 60px;
              margin-right: 8px;

              .f-image {
                width: 100%;
                height: 100%;
                border-radius: 12px;
                overflow: hidden;
                object-fit: cover;
              }

              .f-super {
                z-index: 2;
                position: absolute;
                width: 60px;
                left: 0;
                bottom: 0;
                height: auto;
              }
            }

            .f-right {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              padding: 0px 0px;

              .f-r-name {
                font-size: 14px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.8);
                line-height: 20px;
                margin-bottom: 4px;
              }

              .f-r-desc {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(0, 0, 0, 0.6);
                line-height: 16px;
              }
            }
          }

          .f-item:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .consult-content {
    position: relative;
    background: rgba(242, 239, 255, 1);
    padding: 16px 10px;
    display: flex;
    align-items: center;

    .avatar {
      width: 42px;
      height: 42px;
      border-radius: 12px;
      margin-right: 8px;
      object-fit: cover;
    }

    .right {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;

      .coach-name {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.8);
        line-height: 20px;
        margin-bottom: 3px;
      }

      .desc {
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.6);
        line-height: 16px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .c-btn {
      margin-left: 10px;
      width: 74px;
      height: 31px;
      background: linear-gradient(149deg, #9071ff 0%, #7d9afc 100%);
      border-radius: 16px;
      font-weight: bold;
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      line-height: 31px;
    }
  }

  .consult-content::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #fff;
    top: -1px;
    left: 25px;
  }

  .tip-content {
    position: absolute;
    left: 0;
    top: -30px;
    background-color: rgb(234, 230, 250);
    border-radius: 4px;
    padding: 4px 6px;
    font-size: 11px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.6);
    line-height: 16px;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    margin-bottom: 5px;

    .close {
      margin-left: 6px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      font-size: 8px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .tip-content::after {
    position: absolute;
    left: 10px;
    bottom: -5px;
    content: '';
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 10px solid rgb(234, 230, 250);
  }

  .btn-content {
    position: fixed;
    z-index: 100;
    left: 50%;
    bottom: 30px;
    transform: translate(-50%, 0%);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .btn-item {
      margin-right: 5px;
      position: relative;
      text-align: center;
      width: 122px;
      height: 40px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 20px;
      border: 1px solid #f1f1f1;
      line-height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
    }
    .btn-item:last-child {
      margin-right: 0px;
    }
    .btn-confirm {
      width: 208px;
      background: linear-gradient(149deg, #9071ff 0%, #7d9afc 100%);
      border: none;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;

      .iconfont {
        margin-right: 4px;
        font-weight: 600;
      }
    }
  }

  .banner {
    .image {
      width: 100%;
      height: 120px;
      object-fit: cover;
      border-radius: 8px;
      overflow: hidden;
    }
  }

  .h5-padding {
    height: 100px;
  }

  .download-app {
    width: 327px;
    height: 50px;
    line-height: 50px;
    background: #6236ff;
    border-radius: 25px;
    position: fixed;
    left: 50%;
    bottom: 30px;
    transform: translate(-50%, 0%);
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    z-index: 999;
  }
}

.loading {
  padding-top: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
